import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-container',
	templateUrl: './app-container.component.html',
	styleUrl: './app-container.component.scss',
	standalone: true,
	imports: [NgClass],
})
export class AppContainerComponent {
	@Input({ required: true }) isAuthenticated: boolean | null | undefined;
	@Input({ required: false }) isAdminApplication: boolean | null | undefined;
	@Input({ required: false }) class?: string = '';

	constructor() {}
}
